// extracted by mini-css-extract-plugin
export default {"page":"OO","headerwrap":"PO","headerblock":"QO","textwrapper":"RO","text":"SO","closerlook":"TO","arrowwrap":"UO","icon":"VO","updown":"WO","products":"XO","system":"YO","systemimage":"ZO","cards":"aP","note":"bP","fadein":"cP"};
    if(module.hot) {
      // 1713361652921
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  